import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { JiraIssuesPopover } from './JiraIssuesPopover';
import { jiraSummarySelectors } from '../../../settings/jira/@arch/selectors';
import React from 'react';

import { Popover, Radio } from 'antd';
import { useCurrentUser, useFeatureFlag, useSonarSelector } from '@hooks';

export interface JiraIssuesButtonProps {
	initiativeId: number;
}

export const JiraIssuesButton: React.FC<JiraIssuesButtonProps> = ({ initiativeId }) => {
	const { isReadOnly } = useCurrentUser();
	const jiraActive = useFeatureFlag(FeatureFlag.JiraIntegration);
	const jiraSummary = useSonarSelector(jiraSummarySelectors.data);

	if (isReadOnly || !jiraActive || !jiraSummary?.connected) {
		return null;
	}

	return (
		<Popover
			classNames={ { root: 'jira-issue-popover' } }
			content={ <JiraIssuesPopover initiativeId={ initiativeId } /> }
			destroyOnHidden
			placement='bottom'
			trigger='click'>
			<Radio.Button
				id='jira-issues-button'
				value='issues'>
				{ COPY_SPECIFIC.JIRA_ISSUES }
			</Radio.Button>
		</Popover>
	);
};
